import React from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
    FileIcon,
    Text,
    ContainedButton,
    DownloadIcon,
    StyledCard,
    StyledCardContent,
} from '../index';

import { MONTHS } from '../../constant';

import { StyledButtonWrapper } from './style';

export const PatientHistoryCard = ({ data, onClick, onDetail, onDownload, showTime }) => {
    const date = new Date(data?.date);

    const reccordDate = `Record ${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;

    const ConditionalWrapper = ({ condition, wrapper, children }) =>
        condition ? wrapper(children) : children;

    return (
        <ConditionalWrapper
            condition={onClick}
            wrapper={(children) => (
                <StyledButtonWrapper onClick={onClick}>{children}</StyledButtonWrapper>
            )}
        >
            <StyledCard
                padding="5px 20px"
                variant="outlined"
                style={{ height: '56px' }}
                $hoverBackgroundColor={onClick && 'blue9'}
            >
                <StyledCardContent
                    style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        columnGap: '20px',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FileIcon fill="black" />
                    </div>
                    <Text style={{ flexGrow: 1, textAlign: 'left' }}>{reccordDate}</Text>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {onDetail && (
                            <ContainedButton
                                $icon
                                style={{ width: '24px', height: '24px' }}
                                onClick={onDetail}
                            >
                                <FileIcon />
                            </ContainedButton>
                        )}
                        {onDownload && (
                            <ContainedButton
                                $icon
                                $backgroundColor="pink"
                                style={{ width: '24px', height: '24px' }}
                                onClick={onDownload}
                            >
                                <DownloadIcon />
                            </ContainedButton>
                        )}
                        {showTime && !_.isEmpty(data.patient_summaries) && (
                            <Text $fontSize="12px" $color="gray2">{`${dayjs(
                                data.patient_summaries[0].joinTime
                            ).format('HH:mm')} - ${dayjs(
                                data.patient_summaries[0].leaveTime
                            ).format('HH:mm')}`}</Text>
                        )}
                    </div>
                </StyledCardContent>
            </StyledCard>
        </ConditionalWrapper>
    );
};

PatientHistoryCard.propTypes = {
    data: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onDetail: PropTypes.func,
    onDownload: PropTypes.func,
    showTime: PropTypes.bool,
};
